<template>
  <div class="owner-detail-room-fee">
    <div class="margin-top">
      <el-row class="margin-top-lg">
        <el-col :span="16">
          <span class="margin-right" v-for="(item, index) in aOwnerDetailRoomFeeInfo.payObjs" :key="index">
            <el-checkbox class="checkRoomItem" :value="item.roomId" v-model="aOwnerDetailRoomFeeInfo.payerObjIds"
              @change="_chanagePayerObjId">
              {{ item.floorNum }}-{{ item.unitNum }}-{{ item.roomNum }}
            </el-checkbox>
          </span>
        </el-col>
        <el-col :span="8">
          <el-select v-model="aOwnerDetailRoomFeeInfo.state" @change="_changeContractConfigId" size="small">
            <el-option :label="$t('aOwnerDetailRoomFee.selectStatus')" value="" />
            <el-option :label="$t('aOwnerDetailRoomFee.valid')" value="2008001" />
            <el-option :label="$t('aOwnerDetailRoomFee.chargeEnd')" value="2009001" />
          </el-select>
        </el-col>
      </el-row>

      <div class="margin-top">
        <el-table :data="aOwnerDetailRoomFeeInfo.fees" border style="width: 100%">
          <el-table-column prop="payerObjName" :label="$t('aOwnerDetailRoomFee.room')" align="center" />
          <el-table-column prop="feeName" :label="$t('aOwnerDetailRoomFee.feeItem')" align="center" />
          <el-table-column prop="feeFlagName" :label="$t('aOwnerDetailRoomFee.feeFlag')" align="center" />
          <el-table-column prop="feeTypeCdName" :label="$t('aOwnerDetailRoomFee.feeType')" align="center" />
          <el-table-column prop="amountOwed" :label="$t('aOwnerDetailRoomFee.amountReceivable')" align="center" />
          <el-table-column prop="startTime" :label="$t('aOwnerDetailRoomFee.accountTime')" align="center" />
          <el-table-column :label="$t('aOwnerDetailRoomFee.receivablePeriod')" align="center">
            <template #default="{ row }">
              {{ _getRoomEndTime(row) }}~<br>{{ _getRoomDeadlineTime(row) }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('aOwnerDetailRoomFee.description')" align="center">
            <template #default="{ row }">
              <div v-if="row.computingFormula === '5005' || row.computingFormula === '9009'">
                <div>{{ $t('aOwnerDetailRoomFee.lastDegree') }}: {{ row.preDegrees }}</div>
                <div>{{ $t('aOwnerDetailRoomFee.currentDegree') }}: {{ row.curDegrees }}</div>
                <div>{{ $t('aOwnerDetailRoomFee.unitPrice') }}: {{ row.mwPrice ? row.mwPrice : row.squarePrice }}</div>
                <div>{{ $t('aOwnerDetailRoomFee.additionalFee') }}: {{ row.additionalAmount }}</div>
              </div>
              <div v-else-if="row.computingFormula === '6006'">
                <div>{{ $t('aOwnerDetailRoomFee.usage') }}: {{ _getRoomAttrValue(row.feeAttrs, '390006') }}</div>
                <div>{{ $t('aOwnerDetailRoomFee.unitPrice') }}: {{ row.squarePrice }}</div>
                <div>{{ $t('aOwnerDetailRoomFee.additionalFee') }}: {{ row.additionalAmount }}</div>
              </div>
              <div v-else-if="row.feeTypeCd === '888800010017'" style="width: 150px">
                <div>{{ $t('aOwnerDetailRoomFee.algorithm') }}: {{ _getRoomAttrValue(row.feeAttrs, '390005') }}</div>
                <div>{{ $t('aOwnerDetailRoomFee.usage') }}: {{ _getRoomAttrValue(row.feeAttrs, '390003') }}</div>
              </div>
              <div v-else-if="row.computingFormula === '4004'" style="width: 150px">
                <div>{{ $t('aOwnerDetailRoomFee.feeBasedOnActual') }}</div>
              </div>
              <div v-else>
                <div>{{ $t('aOwnerDetailRoomFee.unitPrice') }}: {{ row.squarePrice }}</div>
                <div v-if="row.feeFlag === '1003006'">{{ $t('aOwnerDetailRoomFee.additionalFee') }}:
                  {{ row.additionalAmount }}</div>
                <div v-else>{{ $t('aOwnerDetailRoomFee.fixedFee') }}: {{ row.additionalAmount }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="stateName" :label="$t('aOwnerDetailRoomFee.status')" align="center" />
          <el-table-column :label="$t('aOwnerDetailRoomFee.operation')" align="center" width="120">
            <template #default="{ row }">
              <el-button v-if="showRestrictButton(row)" size="mini"
                :type="getRestrictButtonType(row)"
                @click="openRestrictDialog(row)">
                {{ getRestrictButtonText(row) }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-row class="margin-top">
          <el-col :span="12">
            <div>{{ $t('aOwnerDetailRoomFee.note1') }}</div>
            <div>{{ $t('aOwnerDetailRoomFee.note2') }}</div>
          </el-col>
          <el-col :span="4">
            <span>{{ $t('aOwnerDetailRoomFee.arrearsSubtotal') }}</span>
            {{ aOwnerDetailRoomFeeInfo.totalAmount }}
          </el-col>
          <el-col :span="8">
            <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
              layout="total, prev, pager, next" :total="total" />
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- 限制门禁延期弹窗 -->
    <el-dialog :title="restrictDialogTitle" :visible.sync="restrictDialogVisible" width="420px" append-to-body>
      <el-form label-width="100px">
        <el-form-item label="延期天数">
          <el-input-number v-model="postponeDays" :min="1" :max="365" style="width:200px"></el-input-number>
          <span style="margin-left:10px;color:#999">1-365天</span>
        </el-form-item>
        <div v-if="currentRestrictRoom" style="padding:10px 0 0 100px;color:#666;font-size:13px">
          <p>房屋：{{ currentRestrictRoom.payerObjName }}</p>
          <p v-if="currentDoorStatus && currentDoorStatus.postponeEndTime">
            当前到期：{{ currentDoorStatus.postponeEndTime }}
          </p>
          <p>到期剩余天数：<span style="color:#E6A23C;font-weight:bold">{{ computedRemainingDays }}</span> 天</p>
        </div>
      </el-form>
      <span slot="footer">
        <el-button @click="restrictDialogVisible = false">取消</el-button>
        <el-button v-if="currentButtonType === 'YELLOW'" type="danger" @click="cancelRestrict">取消延期</el-button>
        <el-button type="primary" @click="confirmRestrict">
          {{ currentButtonType === 'YELLOW' ? '修改延期' : '确认延期' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { listAdminFee,queryAdminOwnerRooms } from '@/api/aCommunity/aOwnerDetailRoomFeeApi'
import { queryRoomDoorAccessStatus, saveRoomDoorAccessRestrict } from '@/api/room/roomApi'
//import { getCommunityId } from '@/api/community/communityApi'
import { dateFormat } from '@/utils/dateUtil'

export default {
  name: 'AOwnerDetailRoomFee',
  data() {
    return {
      DEFAULT_PAGE: 1,
      DEFAULT_ROWS: 30,
      aOwnerDetailRoomFeeInfo: {
        fees: [],
        roomNum: '',
        allOweFeeAmount: '0',
        payObjs: [],
        payerObjIds: [],
        ownerId: '',
        state: '2008001',
        totalAmount: 0
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      // 限制门禁相关数据
      feeLinkIotOn: false,
      roomDoorStatusMap: {},
      restrictDialogVisible: false,
      postponeDays: 0,
      currentRestrictRoom: null,
      currentDoorStatus: null,
      currentButtonType: ''
    }
  },
  computed: {
    // 计算门禁到期剩余天数
    computedRemainingDays() {
      if (!this.currentRestrictRoom) return 0
      const days = this.postponeDays || 0
      if (days <= 0) return 0
      const now = new Date()
      const endDate = new Date(now)
      endDate.setDate(endDate.getDate() + days)
      const diffMs = endDate - now
      return Math.ceil(diffMs / (1000 * 60 * 60 * 24))
    },
    // 门禁延期弹窗标题
    restrictDialogTitle() {
      if (!this.currentDoorStatus) return '设置门禁延期'
      if (this.currentDoorStatus.buttonType === 'YELLOW') return '修改门禁延期'
      return '设置门禁延期'
    }
  },
  methods: {
    open(data) {
      this.aOwnerDetailRoomFeeInfo.ownerId = data.ownerId
      this._loadDetailRoomsData()
    },
    handleNotify() {
      this._loadAOwnerDetailRoomFeeData(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this._loadAOwnerDetailRoomFeeData(val, this.DEFAULT_ROWS)
    },
    async _loadAOwnerDetailRoomFeeData(page, row) {
      const payerObjIds = this.aOwnerDetailRoomFeeInfo.payerObjIds.join(',')
      const param = {
        page,
        row,
        payerObjIds,
        state: this.aOwnerDetailRoomFeeInfo.state
      }

      try {
        const response = await listAdminFee(param)
        this.total = response.total
        this.aOwnerDetailRoomFeeInfo.fees = response.fees
        this.currentPage = page

        let totalAmount = 0.0
        this.aOwnerDetailRoomFeeInfo.fees.forEach(item => {
          totalAmount += parseFloat(item.amountOwed)
        })
        this.aOwnerDetailRoomFeeInfo.totalAmount = totalAmount.toFixed(2)
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    _getRoomAttrValue(attrs, specCd) {
      let value = ""
      attrs.forEach(item => {
        if (item.specCd === specCd) {
          value = item.value
          return
        }
      })
      return value
    },
    _getRoomDeadlineTime(fee) {
      if (fee.amountOwed === 0 && fee.endTime === fee.deadlineTime) {
        return "-"
      }
      if (fee.state === '2009001') {
        return "-"
      }
      return dateFormat(fee.deadlineTime)
    },
    _getRoomEndTime(fee) {
      if (fee.state === '2009001') {
        return "-"
      }
      return dateFormat(fee.endTime)
    },
    _chanagePayerObjId() {
      this._loadAOwnerDetailRoomFeeData(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
      this._loadDoorStatus()
    },
    _changeContractConfigId() {
      this._loadAOwnerDetailRoomFeeData(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    async _loadDetailRoomsData() {
      const param = {
        ownerId: this.aOwnerDetailRoomFeeInfo.ownerId,
        page: 1,
        row: 100
      }
      this.aOwnerDetailRoomFeeInfo.payerObjIds = []

      try {
        const response = await queryAdminOwnerRooms(param)
        this.aOwnerDetailRoomFeeInfo.payObjs = response.rooms
        response.rooms.forEach(room => {
          this.aOwnerDetailRoomFeeInfo.payerObjIds.push(room.roomId)
        })
        this._loadAOwnerDetailRoomFeeData(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
        // 加载门禁状态
        await this._loadDoorStatus()
      } catch (error) {
        console.error('请求失败:', error)
      }
    },

    // ========== 限制门禁相关方法 ==========

    // 加载门禁限制状态
    async _loadDoorStatus() {
      try {
        // 先重置状态
        this.feeLinkIotOn = false
        this.roomDoorStatusMap = {}
        const roomIds = this.aOwnerDetailRoomFeeInfo.payerObjIds.join(',')
        if (!roomIds) {
          console.log('doorStatus: 无房屋ID，跳过')
          return
        }
        console.log('doorStatus: 加载门禁状态, roomIds=', roomIds)
        const res = await queryRoomDoorAccessStatus(this.getCommunityId(), roomIds)
        console.log('doorStatus: API返回=', res)
        // res = axios响应, res.data = ResultVo {code, msg, data: {feeLinkIotOn, roomStatusMap}}
        const resultVo = res.data || {}
        const statusData = resultVo.data || {}
        this.feeLinkIotOn = statusData.feeLinkIotOn || false
        this.roomDoorStatusMap = statusData.roomStatusMap || {}
        console.log('doorStatus: feeLinkIotOn=', this.feeLinkIotOn, 'roomDoorStatusMap=', this.roomDoorStatusMap)
      } catch (error) {
        console.error('加载门禁状态失败:', error)
      }
    },

    // 是否显示限制门禁按钮
    showRestrictButton(row) {
      if (!this.feeLinkIotOn) return false
      const status = this.roomDoorStatusMap[row.payerObjId]
      return status && status.buttonType !== 'NONE'
    },

    // 获取按钮类型
    getRestrictButtonType(row) {
      const status = this.roomDoorStatusMap[row.payerObjId]
      return status && status.buttonType === 'RED' ? 'danger' : 'warning'
    },

    // 获取按钮文本
    getRestrictButtonText(row) {
      const status = this.roomDoorStatusMap[row.payerObjId]
      if (!status) return ''
      if (status.buttonType === 'RED') {
        return status.hasPostpone ? '重新限制' : '限制门禁'
      }
      return '已延期'
    },

    // 打开限制门禁弹窗
    openRestrictDialog(row) {
      const status = this.roomDoorStatusMap[row.payerObjId]
      if (!status) return
      this.currentRestrictRoom = row
      this.currentDoorStatus = status
      this.currentButtonType = status.buttonType || 'RED'
      this.postponeDays = status.postponeDays ? parseInt(status.postponeDays) : 1
      this.restrictDialogVisible = true
    },

    // 确认延期
    async confirmRestrict() {
      if (!this.postponeDays || this.postponeDays < 1 || this.postponeDays > 365) {
        this.$message.error('延期天数必须在1-365天之间')
        return
      }
      if (!this.currentRestrictRoom) return
      try {
        await saveRoomDoorAccessRestrict({
          communityId: this.getCommunityId(),
          roomId: this.currentRestrictRoom.payerObjId,
          postponeDays: this.postponeDays,
          action: 'POSTPONE',
          userName: (this.$getUser() || {}).name || '管理员'
        })
        this.$message.success('延期设置成功')
        this.restrictDialogVisible = false
        await this._loadDoorStatus()
      } catch (error) {
        console.error('延期设置失败:', error)
        this.$message.error(error.response ? error.response.data.msg : '延期设置失败')
      }
    },

    // 取消延期
    async cancelRestrict() {
      if (!this.currentRestrictRoom) return
      try {
        await saveRoomDoorAccessRestrict({
          communityId: this.getCommunityId(),
          roomId: this.currentRestrictRoom.payerObjId,
          action: 'CANCEL',
          userName: (this.$getUser() || {}).name || '管理员'
        })
        this.$message.success('已取消延期')
        this.restrictDialogVisible = false
        await this._loadDoorStatus()
      } catch (error) {
        console.error('取消延期失败:', error)
        this.$message.error(error.response ? error.response.data.msg : '取消延期失败')
      }
    }
  }
}
</script>

<style scoped>
.margin-top {
  margin-top: 20px;
}

.margin-top-lg {
  margin-top: 30px;
}

.margin-right {
  margin-right: 15px;
}
</style>
